import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';
import security from './users/Security';

const gridCols = responsive({
  0: 'repeat(1, 1fr)',
  3: 'repeat(2, 1fr)',
  5: 'repeat(4, 1fr)',
});

const spanAll = responsive({
  0: 'span 1',
  3: 'span 2',
  5: 'span 4',
});

const spanHalf = responsive({
  0: 'span 1',
  5: 'span 2',
});

const users: ThemeUICSSObject = {
  upsertion: {
    '.schParameters_title': {
      background: 'palette.background.paper',
      '>span .fieldLabel__container:first-of-type': {
        px: spacing(7),
        pt: spacing(7),
      },
      '.fldSpanHalf': {
        gridColumn: spanHalf,
      },
    },
    fieldset: {
      display: 'grid',
      gridTemplateColumns: gridCols,
      gap: spacing(4),
      p: spacing(7),
      border: 'none',
      ...getColorsByPath('tab'),
      '&.lowerBottomGap': {
        pb: spacing(5),
      },
      '&.lowerTopGap': {
        pt: spacing(5),
      },
      '&.notGrid': {
        pt: 0,
        display: 'block',
      },

      '.flagContainer': {
        gridColumn: spanHalf,
        display: 'grid',
        flexDirection: 'column',
        alignItems: 'center',
        gap: spacing(4),
      },

      '.checkbox': {
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'start',
        gap: spacing(4),
        '.semicolon': {
          display: 'none',
        },
      },

      '.imageSelector': {
        gridColumn: spanHalf,
        alignItems: 'center',
        '.buttonContainer': {
          gridColumn: spanHalf,
          alignSelf: 'center',
          '&>div': { gap: spacing(0) },

          position: 'relative',
          '.deleteImage': {
            position: 'absolute',
            right: 0,
            top: 0,
            color: 'palette.text.primary',
            backgroundColor: 'white',
            borderRadius: '100%',
            p: '4px',
          },
          '.imageContainer': {
            p: spacing(4),
          },
        },
      },

      '.textarea': {
        textarea: {
          height: '15vh',
          mt: spacing(1),
        },
      },

      '.fldSpanAll': {
        gridColumn: spanAll,
      },

      '.fldSpanHalf': {
        gridColumn: spanHalf,
      },

      '& label.fieldWrapper': {
        alignItems: 'stretch',

        '&.imageSelector': {
          alignItems: 'center',
        },
      },
    },
  },

  security,
};

export default users;
